import type { Translate } from 'next-translate';
import React from 'react';
import type { LandingList } from '@/types';
import styles from './LandingListItem.module.scss';

interface Props {
	item: LandingList;
	t: Translate;
	inARow?: boolean;
}
export const LandingListItem: React.FC<Props> = ({
	item,
	t,
	inARow = false,
}) => {
	return (
		<li
			key={item.title}
			className={`${styles['item']} ${
				inARow ? styles['item__withoutTitle'] : ''
			}`}
		>
			{!inARow ? (
				<>
					{item.title && (
						<h3 className={styles['item__title']}>
							<span aria-hidden='true'>{item.icon}</span> {t(item.title)}
						</h3>
					)}
					<p className={styles['item__subtitle']}>
						{item?.subtitle ? t(item?.subtitle) : ''}
					</p>
				</>
			) : (
				<div className={styles['item__without-title']}>
					{item.icon ? item.icon : ''}
					<h3 className={styles['item__subtitle']}>
						{item?.subtitle ? t(item?.subtitle) : ''}
					</h3>
				</div>
			)}
		</li>
	);
};
